<template>
  <div class="text-center">
    <v-dialog v-model="dialog" max-width="680" persistent>
      <v-card class="vd-card">
        <v-card-title class="vd-hero py-3">
          <div class="d-flex align-center" style="gap: 12px;">
            <v-avatar color="white" size="40" class="elevation-1">
              <v-icon color="teal darken-3">mdi-file-document-check-outline</v-icon>
            </v-avatar>
            <div>
              <div class="text-h6 white--text">Verificar documento</div>
              <div class="text-body-2 white--text" style="opacity: 0.8;">
                {{ persona ? persona.nombres : '' }}
              </div>
            </div>
          </div>
        </v-card-title>

        <v-card-text class="pt-4 pb-4" style="max-height: 560px; overflow-y: auto;">

          <!-- Cargando -->
          <div v-if="loading" class="d-flex align-center justify-center py-10" style="gap: 12px;">
            <v-progress-circular indeterminate color="teal" size="28" />
            <span class="grey--text">Cargando documento...</span>
          </div>

          <!-- Sin documento -->
          <div v-else-if="!docUrl && !loading" class="text-center py-10 grey--text">
            <v-icon large color="grey lighten-2">mdi-file-remove-outline</v-icon>
            <div class="mt-2 caption">No se encontró documento de identidad registrado</div>
          </div>

          <!-- Documento -->
          <template v-else>
            <div class="vd-doc-wrap">
              <img v-if="esImagen" :src="docUrl" class="vd-doc-img" alt="Documento de identidad" />
              <iframe v-else :src="docUrl" class="vd-doc-pdf" title="Documento de identidad" />
            </div>
          </template>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-3" style="gap: 8px;">
          <v-spacer></v-spacer>
          <v-btn color="grey" text :disabled="saving" @click="cerrar()">Cerrar</v-btn>
          <v-btn
            color="red darken-1"
            class="white--text"
            :loading="saving && accionPendiente === false"
            :disabled="saving || !docUrl"
            @click="guardar(false)"
          >
            <v-icon left small>mdi-close-circle-outline</v-icon>
            No verificado
          </v-btn>
          <v-btn
            color="teal darken-1"
            class="white--text"
            :loading="saving && accionPendiente === true"
            :disabled="saving || !docUrl"
            @click="guardar(true)"
          >
            <v-icon left small>mdi-check-circle-outline</v-icon>
            Verificado
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import gql from 'graphql-tag';
  import xaxios from '@/xaxios';
  import { documento_persona } from './utils';

  export default {
    data() {
      return {
        loading: false,
        saving: false,
        dialog: false,
        persona: null,
        docUrl: null,
        esImagen: false,
        accionPendiente: null,
      };
    },
    methods: {
      async openmodal(persona) {         
        this.persona = persona.estudiante;
        this.docUrl = null;
        this.esImagen = false;
        this.accionPendiente = null;
        this.dialog = true;
        this.cargar_documento();
      },
      async cargar_documento() {
        this.loading = true;
        try {
          // 1. Obtener UUID del documento de la persona
          const doc = await documento_persona(this.persona.id);
          window.console.log('doc',doc);
          if (!doc || !doc.documento_identidad) {
            this.loading = false;
            return;
          }

          

          // 2. Descargar archivo desde el servidor de archivos usando el UUID
          const fileUrl = `${process.env.VUE_APP_SERVERFILES}${doc.documento_identidad}`;
          const fileRes = await xaxios.get(fileUrl).then(({ data }) => data).catch(() => null);
          window.console.log('fileRes',fileRes)
          if (!fileRes || !fileRes.file64) {
            this.loading = false;
            return;
          }

          this.esImagen = (fileRes.mimetype || '').startsWith('image/');
          this.docUrl = `data:${fileRes.mimetype};base64,${fileRes.file64}`;
        } catch (e) {
          this.$root.$notify.show('Error al cargar el documento', { color: 'red', x: 'right' });
        } finally {
          this.loading = false;
        }
      },
      async guardar(is_verificado) {
        this.saving = true;
        this.accionPendiente = is_verificado;
        const sql = gql`mutation{ updateIsVerificado(id:${this.persona.id}, is_verificado:${is_verificado}){ ok } }`;
        try {
          const { data } = await this.$apollo.mutate({ mutation: sql });
          const res = data && data.updateIsVerificado ? data.updateIsVerificado : null;
          if (res && res.ok) {
            const msg = is_verificado ? 'Persona marcada como verificada' : 'Persona marcada como no verificada';
            this.$root.$notify.show(msg, { color: is_verificado ? 'teal' : 'orange', x: 'right' });
            this.$emit('onVerificado', { persona_id: this.persona.id, is_verificado });
            this.cerrar();
          } else {
            this.$root.$notify.show(res ? res.message : 'No se pudo guardar', { color: 'red', x: 'right' });
          }
        } catch (e) {
          this.$root.$notify.show('Error al guardar la verificación', { color: 'red', x: 'right' });
        } finally {
          this.saving = false;
          this.accionPendiente = null;
        }
      },
      cerrar() {
        this.dialog = false;
      },
    },
    mounted() {},
  };
</script>

<style scoped>
.vd-card { border-radius: 14px; overflow: hidden; }
.vd-hero { background: linear-gradient(120deg, #00695c 0%, #00897b 60%, #26a69a 100%); }

.vd-doc-wrap {
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  overflow: hidden;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 340px;
}
.vd-doc-img {
  max-width: 100%;
  max-height: 460px;
  object-fit: contain;
  display: block;
}
.vd-doc-pdf {
  width: 100%;
  height: 460px;
  border: none;
}
</style>
